(function (angular) {
    'use strict';

    angular.module('reports')
        .factory('chartFactoryService', [
            function () {

                var colorSet = {};

                var fac = {
                    singleChannelDataSetMain: function (label, data, backgroundColor, borderColor, color) {
                        colorSet[label] = color;
                        return {
                            type: 'line',
                            label: label,
                            data: data,
                            backgroundColor: backgroundColor,
                            borderColor: borderColor,
                            showLine: true,
                            pointStyle: 'circle',
                            borderWidth: 2,
                            radius: 0,
                            fill: false
                        };
                    },
                    singleChannelDataSetBar: function (backgroundColor, data) {
                        return {
                            backgroundColor: backgroundColor,
                            borderWidth: 0,
                            data: data,
                            datalabels: {
                                align: 'end',
                                anchor: 'end'
                            }
                        };
                    },
                    singleChannelDataSetPie: function (data, colors) {
                        return {
                            data: data,
                            backgroundColor: colors,
                            borderWidth: 0,
                            fill: true,
                            maintainAspectRatio: false,
                            startAngle: 0
                        };
                    },
                    singleChannelDataSetDelivery: function (data, backgroundColor) {
                        return {
                            backgroundColor: backgroundColor,
                            borderWidth: 0,
                            data: data,
                            datalabels: {
                                align: 'end',
                                anchor: 'end'
                            }
                        };
                    },

                    singleChannelDataOptionsMain: function (min, max, by, maxY) {
                        return {
                            layout: {
                                padding: {
                                    left: 20,
                                    right: 0,
                                    top: 20,
                                    bottom: 30
                                }
                            },
                            plugins: {
                                datalabels: {
                                    display: false
                                }
                            },
                            tooltips: {
                                mode: 'index',
                                intersect: false,
                                bodyFontColor: '#fff',
                                callbacks: {
                                    title: function (tooltipItem, chart) {
                                        if (tooltipItem && tooltipItem[0]) {
                                            tooltipItem = tooltipItem[0];
                                            switch (by) {
                                                case 'hour':
                                                    return moment(tooltipItem.xLabel).format('HH:mm');

                                                case 'day':
                                                    return moment(tooltipItem.xLabel).format('DD/MM/YYYY');

                                                case 'month':
                                                    return moment(tooltipItem.xLabel).format('M/YYYY');

                                                default:
                                                    return moment(tooltipItem.xLabel).format('M/YYYY');

                                            }
                                        }

                                    },

                                    labelColor: function (tooltipItem, chart) {

                                        return {
                                            borderColor: colorSet[chart.config.data.datasets[tooltipItem.datasetIndex].label],
                                            backgroundColor: colorSet[chart.config.data.datasets[tooltipItem.datasetIndex].label],
                                            bodyFontColor: '#fff'
                                        };
                                    },
                                    label: function (tooltipItem, data) {
                                        if (tooltipItem.yLabel > 0) {
                                            var label = data.datasets[tooltipItem.datasetIndex].label || '';

                                            if (label) {
                                                label += ': ';
                                            }
                                            label += tooltipItem.yLabel;
                                            return label;
                                        }

                                    },
                                    labelTextColor: function (tooltipItem, chart) {
                                        return '#fff';
                                    }
                                }
                            },
                            legend: {
                                display: true,
                                position: 'bottom',
                                labels: {
                                    fontColor: "#666",
                                    fontFamily: "Lato",
                                    usePointStyle: true
                                }
                            },
                            scales: {
                                xAxes: [{
                                    type: 'time',
                                    distribution: 'linear',
                                    gridLines: {
                                        display: false
                                    },
                                    time:
                                    {
                                        min: min ? min : 0,
                                        max: max,
                                        unit: by,
                                        fillGapsWithZero: true
                                    },
                                }],

                                yAxes: [
                                    {
                                        id: 'y-axis-1',
                                        type: 'linear',
                                        gridLines: {
                                            display: false,
                                            drawBorder: true,
                                        },

                                        ticks: {
                                            beginAtZero: true,
                                            suggestedMax: maxY * 1.03,
                                            minStepSize: 1,
                                            callback: function (value, index, values) {
                                                if (value === Math.round(value)) return value;
                                            }
                                        },
                                        display: true,
                                        position: 'left',
                                    }]
                            }
                        };

                    },
                    singleChannelDataOptionsPie: {
                        layout: {
                            padding: {
                                left: 0,
                                right: 0,
                                top: 20,
                                bottom: 20
                            }
                        },
                        tooltips: {
                            enabled: false
                        },
                        cutoutPercentage: 0,
                        legend: false,
                        legendCallback: function (chart) {
                            var configData = chart.config.data;
                            var data = configData.datasets[0].data;
                            var sum = data.reduce(function (a, b) {
                                return a + b;
                            }, 0) || 1;
                            var template = "<table>";
                            for (var i in configData.labels) {
                                template += "<tr><td>" + configData.labels[i] + "</td><td class='vertical-middle'><span style='background-color: " + configData.defaultColors[i] + "'></span></td><td>" + data[i] + "</td></tr>";
                            }
                            template += "</table>";
                            return template;
                        },
                        plugins: {
                            datalabels: {
                                display: false
                            }
                        }
                    },
                    singleChannelDataOptionsDeliver: function (deliverySum) {
                        return {
                            plugins: {
                                datalabels: {
                                    color: 'black',
                                    display: function (context) {
                                        return context.dataset.data[context.dataIndex] > 0;
                                    },
                                    font: {
                                        weight: 'normal'
                                    },
                                    formatter: function (value, context) {
                                        var data = context.dataset.data;
                                        var sum = data.reduce(function (a, b) {
                                            return a + b;
                                        }, 0) || 1;
                                        return Math.round(value / sum * 100) + '%';
                                    },

                                    title: false
                                }
                            },
                            layout: {
                                padding: {
                                    left: 20,
                                    right: 0,
                                    top: 50,
                                    bottom: 30
                                }
                            },
                            scales: {
                                xAxes: [{
                                    gridLines: {
                                        display: false
                                    },
                                    ticks: {
                                        beginAtZero: true
                                    },
                                    display: true
                                }],
                                yAxes: [
                                    {
                                        id: 'y-axis-1',
                                        gridLines: {
                                            display: false,
                                            drawBorder: true,
                                        },

                                        ticks: {
                                            beginAtZero: true,
                                            maxTicksLimit: 2,
                                            suggestedMax: deliverySum
                                        },
                                        display: true,
                                        position: 'left'
                                    }]
                            },
                            legend: false
                        };
                    },
                    singleChannelDataOptionsBar: {
                        responsive: false,
                        plugins: {
                            datalabels: {
                                color: 'black',
                                display: function (context) {
                                    return context.dataset.data[context.dataIndex] > 0;
                                },
                                font: {
                                    weight: 'normal'
                                },
                                formatter: function (value, context) {
                                    if (context.dataIndex == 0) {
                                        return value;
                                    }
                                    return value + ' (' + Math.round(value / Math.max.apply(Math, context.dataset.data) * 100) + '%)';
                                },

                                title: false
                            }
                        },
                        layout: {
                            padding: {
                                left: 20,
                                right: 80,
                                top: 50,
                                bottom: 0
                            }
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    beginAtZero: true
                                },
                                display: false
                            }],
                            yAxes: [
                                {
                                    id: 'y-axis-1',
                                    gridLines: {
                                        display: false,
                                        drawBorder: false,
                                    },

                                    ticks: {
                                        beginAtZero: true,
                                    },
                                    display: true,
                                    position: 'left'
                                }]
                        },
                        legend: false
                    },
                    verifyDataOptionsBar: {
                        responsive: false,
                        plugins: {
                            datalabels: {
                                color: 'black',
                                display: function (context) {
                                    return context.dataset.data[context.dataIndex] > 0;
                                },
                                font: {
                                    weight: 'normal'
                                },
                                formatter: function (value, context) {
                                    var data = context.dataset.data;
                                    var sum = data.reduce(function (a, b) {
                                        return a + b;
                                    }, 0) || 1;
                                    return value + ' (' + Math.round(value / sum * 100) + '%)';
                                },

                                title: false
                            }
                        },
                        layout: {
                            padding: {
                                left: 20,
                                right: 80,
                                top: 50,
                                bottom: 0
                            }
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    beginAtZero: true
                                },
                                display: false
                            }],
                            yAxes: [
                                {
                                    id: 'y-axis-1',
                                    gridLines: {
                                        display: false,
                                        drawBorder: false,
                                    },

                                    ticks: {
                                        beginAtZero: true,
                                    },
                                    display: true,
                                    position: 'left'
                                }]
                        },
                        legend: false
                    },
                    fillScatteredTimeScaleDataPlugin: {
                        beforeUpdate: function (c) {

                            /* Get time object if exists */
                            var timeAxis = c.options.scales ? c.options.scales.xAxes[0].time : false;

                            /* If time object not exists or we are not filling gaps with 0s, abort */
                            if (!timeAxis || !timeAxis.fillGapsWithZero) return;



                            /* 
                            Loop through the datasets.
                            Find the min and max date, and add all dates/values to assoc.
                            */
                            var datasets = c.data.datasets;
                            for (var index in datasets) {
                                var min = moment(timeAxis.min), max = moment(timeAxis.max), newData = [], assoc = {};
                                var dates = datasets[index].data
                                if (dates.length) {
                                    var diff = max.diff(min, 'days');
                                    var minUnit = 'day'
                                    if (diff < 3) {
                                        minUnit = 'hour';
                                    }
                                    else if (diff < 50 && diff >= 3) {
                                        minUnit = 'day';
                                    }
                                    else if (diff < 180 && diff >= 50) {
                                        minUnit = 'day';
                                    }
                                    else if (diff >= 180 && diff < 1095) {
                                        minUnit = 'month';
                                    }
                                    else {
                                        minUnit = 'year';
                                    }
                                    for (var i = 0; i < dates.length; i++) {
                                        /* Store all in assoc array */
                                        assoc[moment(dates[i].x).startOf(minUnit).format(timeAxis.parser)] = dates[i];
                                    }

                                    /* From the min date, and looping by minUnit until max date */


                                    for (var d = min; max.diff(d) > 0; d.add(1, minUnit)) {

                                        /* Current date */
                                        var cur = d.format(timeAxis.parser);

                                        /* Add zero for day if not represented */
                                        if (!assoc[cur]) {
                                            newData.push({ x: cur, y: 0 });
                                        } else {
                                            newData.push(assoc[cur]);
                                        }
                                    }

                                    /* Replace the data */
                                    datasets[index].data = newData;
                                }
                            }
                            return;
                        }
                    },
                    roundedCornersBars: function () {

                        var ctx = this._chart.ctx;
                        var vm = this._view;
                        var left, right, top, bottom, signX, signY, borderSkipped, radius;
                        var borderWidth = vm.borderWidth;
                        // Set Radius Here
                        // If radius is large enough to cause drawing errors a max radius is imposed
                        var cornerRadius = 8;

                        if (!vm.horizontal) {
                            // bar

                            //overwriting size of bar;
                            vm.width = vm.width >= 20 ? 20 : vm.width;

                            left = vm.x - vm.width / 2;
                            right = vm.x + vm.width / 2;
                            top = vm.y;
                            bottom = vm.base;
                            signX = 1;
                            signY = bottom > top ? 1 : -1;
                            borderSkipped = vm.borderSkipped || 'bottom';
                        } else {
                            // horizontal bar

                            //overwriting size of bar;
                            vm.height = vm.height >= 20 ? 20 : vm.height;

                            left = vm.base;
                            right = vm.x;
                            top = vm.y - vm.height / 2;
                            bottom = vm.y + vm.height / 2;
                            signX = right > left ? 1 : -1;
                            signY = 1;
                            borderSkipped = vm.borderSkipped || 'left';
                        }

                        // Canvas doesn't allow us to stroke inside the width so we can
                        // adjust the sizes to fit if we're setting a stroke on the line
                        if (borderWidth) {
                            // borderWidth shold be less than bar width and bar height.
                            var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
                            borderWidth = borderWidth > barSize ? barSize : borderWidth;
                            var halfStroke = borderWidth / 2;
                            // Adjust borderWidth when bar top position is near vm.base(zero).
                            var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
                            var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
                            var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
                            var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
                            // not become a vertical line?
                            if (borderLeft !== borderRight) {
                                top = borderTop;
                                bottom = borderBottom;
                            }
                            // not become a horizontal line?
                            if (borderTop !== borderBottom) {
                                left = borderLeft;
                                right = borderRight;
                            }
                        }

                        ctx.beginPath();
                        ctx.fillStyle = vm.backgroundColor;
                        ctx.strokeStyle = vm.borderColor;
                        ctx.lineWidth = borderWidth;

                        // Corner points, from bottom-left to bottom-right clockwise
                        // | 1 2 |
                        // | 0 3 |
                        var corners = [
                            [left, bottom],
                            [left, top],
                            [right, top],
                            [right, bottom]
                        ];

                        // Find first (starting) corner with fallback to 'bottom'
                        var borders = ['bottom', 'left', 'top', 'right'];
                        var startCorner = borders.indexOf(borderSkipped, 0);
                        if (startCorner === -1) {
                            startCorner = 0;
                        }

                        function cornerAt(index) {
                            return corners[(startCorner + index) % 4];
                        }

                        // Draw rectangle from 'startCorner'
                        var corner = cornerAt(0);
                        var width, height, x, y, nextCorner, nextCornerId
                        var x_tl, x_tr, y_tl, y_tr;
                        var x_bl, x_br, y_bl, y_br;
                        ctx.moveTo(corner[0], corner[1]);

                        for (var i = 1; i < 4; i++) {
                            corner = cornerAt(i);
                            nextCornerId = i + 1;
                            if (nextCornerId == 4) {
                                nextCornerId = 0
                            }

                            nextCorner = cornerAt(nextCornerId);

                            width = corners[2][0] - corners[1][0];
                            height = corners[0][1] - corners[1][1];
                            x = corners[1][0];
                            y = corners[1][1];

                            radius = cornerRadius;

                            // Fix radius being too large        
                            if (radius > Math.abs(height) / 2) {
                                radius = Math.floor(Math.abs(height) / 2);
                            }
                            if (radius > Math.abs(width) / 2) {
                                radius = Math.floor(Math.abs(width) / 2);
                            }

                            if (height < 0) {
                                // Negative values in a standard bar chart
                                x_tl = x; x_tr = x + width;
                                y_tl = y + height; y_tr = y + height;

                                x_bl = x; x_br = x + width;
                                y_bl = y; y_br = y;

                                // Draw
                                ctx.moveTo(x_bl + radius, y_bl);
                                ctx.lineTo(x_br - radius, y_br);
                                ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);
                                ctx.lineTo(x_tr, y_tr + radius);
                                ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr);
                                ctx.lineTo(x_tl + radius, y_tl);
                                ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);
                                ctx.lineTo(x_bl, y_bl - radius);
                                ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);

                            } else if (width < 0) {
                                // Negative values in a horizontal bar chart
                                x_tl = x + width; x_tr = x;
                                y_tl = y; y_tr = y;

                                x_bl = x + width; x_br = x;
                                y_bl = y + height; y_br = y + height;

                                // Draw
                                ctx.moveTo(x_bl + radius, y_bl);
                                ctx.lineTo(x_br - radius, y_br);
                                ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);
                                ctx.lineTo(x_tr, y_tr + radius);
                                ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr);
                                ctx.lineTo(x_tl + radius, y_tl);
                                ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);
                                ctx.lineTo(x_bl, y_bl - radius);
                                ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);

                            } else {
                                //Positive Value
                                ctx.moveTo(x + radius, y);
                                ctx.lineTo(x + width - radius, y);
                                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                                ctx.lineTo(x + width, y + height - radius);
                                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                                ctx.lineTo(x + radius, y + height);
                                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                                ctx.lineTo(x, y + radius);
                                ctx.quadraticCurveTo(x, y, x + radius, y);
                            }
                        }

                        ctx.fill();
                        if (borderWidth) {
                            ctx.stroke();
                        }
                    }
                };

                return fac;


            }
        ]);
})(window.angular);